import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import produce from 'immer';

import {
  ContentEmailSpecList,
  CreateContentEmailMutation,
  GetContentEmailSpecsDocument,
} from 'api';
import { CONTENT_EMAIL_LIMIT } from 'constants/index';

export default (cache: DataProxy, result: ExecutionResult<CreateContentEmailMutation>) => {
  const { createContentEmailSpec } = result.data;
  const recurringOnly = !!createContentEmailSpec.delivery_interval;

  const { getContentEmailSpecs } = cache.readQuery({
    query: GetContentEmailSpecsDocument,
    variables: { data: { limit: CONTENT_EMAIL_LIMIT, recurringOnly } },
  });

  if (!getContentEmailSpecs) {
    return;
  }

  const nextState = produce(getContentEmailSpecs, (draftState: ContentEmailSpecList) => {
    draftState.items.splice(0, 0, createContentEmailSpec);
  });

  cache.writeQuery({
    query: GetContentEmailSpecsDocument,
    data: {
      getContentEmailSpecs: nextState,
    },
  });
};
